import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
/* import { full } from "./shared/routes/full.routes";
import { content } from "./shared/routes/routes"; */

import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'app',
        pathMatch: 'full'
    },
    {
        path: 'app',
        component: ContentComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
    },
    {
        path: 'gestion-camiones',
        component: FullComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/gestion-camiones/gestion-camiones.module').then(m => m.GestionCamionesModule)
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: '**',
        redirectTo: 'app'
    }
];

@NgModule({
    imports: [[RouterModule.forRoot(routes, {
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
        relativeLinkResolution: 'legacy'
    })],
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
